import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-bold text-primary-500 font-heading whitespace-nowrap">
              神马视频
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              神马视频提供91视频、91在线视频、97视频、51视频高清影视大全，免费在线观看，不缓冲流畅播放，电视剧电影一应俱全。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">
              视频分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">
              热门推荐
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/video/kuangbiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  狂飙
                </Link>
              </li>
              <li>
                <Link to="/video/liulangdiqiu2" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  流浪地球2
                </Link>
              </li>
              <li>
                <Link to="/video/fanhua" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  繁花
                </Link>
              </li>
              <li>
                <Link to="/video/qingyunian2" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  庆余年·第二季
                </Link>
              </li>
              <li>
                <Link to="/video/lingshi-bairen" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  灵笼·终章
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-3">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  用户口碑
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 神马视频 ShenMa Video. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}